import React from 'react';
import './PropertyDetails.css';

/**
 * Full-page skeleton for property details — mirrors topbar + gallery + meta
 * so the first load never shows a blank or half-empty screen.
 */
const PropertyDetailsSkeleton = () => (
  <div className="pd-page pd-skeleton-page" aria-busy="true" aria-label="Loading property">
    <div className="pd-skel-topbar">
      <div className="pd-skel-pill pd-skel-shimmer" />
      <div className="pd-skel-topbar-right">
        <div className="pd-skel-chip pd-skel-shimmer" />
        <div className="pd-skel-chip pd-skel-shimmer" style={{ width: 72 }} />
        <div className="pd-skel-btn pd-skel-shimmer" />
        <div className="pd-skel-btn pd-skel-shimmer" />
      </div>
    </div>

    <div className="pd-hero pd-skel-hero">
      <div className="pd-gal-col">
        <div className="pd-skel-gallery pd-skel-shimmer" />
        <div className="pd-skel-thumbs">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="pd-skel-thumb pd-skel-shimmer" />
          ))}
        </div>
      </div>
      <div className="pd-skel-info">
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '72%', height: 26 }} />
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '48%', height: 16, marginTop: 10 }} />
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '40%', height: 28, marginTop: 18 }} />
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '92%', height: 12, marginTop: 20 }} />
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '84%', height: 12, marginTop: 8 }} />
        <div className="pd-skel-line pd-skel-shimmer" style={{ width: '70%', height: 12, marginTop: 8 }} />
        <div className="pd-skel-cta-row">
          <div className="pd-skel-cta pd-skel-shimmer" />
          <div className="pd-skel-cta pd-skel-shimmer" />
        </div>
      </div>
    </div>

    <div className="pd-skel-blocks">
      {[1, 2, 3].map((i) => (
        <div key={i} className="pd-skel-block">
          <div className="pd-skel-line pd-skel-shimmer" style={{ width: '36%', height: 18, marginBottom: 14 }} />
          <div className="pd-skel-line pd-skel-shimmer" style={{ width: '100%', height: 12, marginBottom: 8 }} />
          <div className="pd-skel-line pd-skel-shimmer" style={{ width: '90%', height: 12, marginBottom: 8 }} />
          <div className="pd-skel-line pd-skel-shimmer" style={{ width: i === 2 ? '60%' : '78%', height: 12 }} />
        </div>
      ))}
    </div>
  </div>
);

export default PropertyDetailsSkeleton;
